export default __webpack_public_path__ + "static/media/OPEL.f9c85d49.png";